import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

// @material-ui/core components
import { Input, MenuItem, Select, InputLabel, FormControl } from "@mui/material";

// @mui/icons-material
import Clear from "@mui/icons-material/Clear";
import Check from "@mui/icons-material/Check";

// core components
import stylesFunction from "../../assets/jss/material-dashboard-react/components/customInputStyle.js";
import { getBaseSxStyle, getKeyArray } from "../../utils/getSxStyle.js";

export default function CustomSelect(props) {
    const styles = stylesFunction();

    const { formControlProps, labelText, id, labelProps, inputProps, options, error, success } = props;

    // const labelClasses = classNames({
    //     [" " + classes.labelRootError]: error,
    //     [" " + classes.labelRootSuccess]: success && !error,
    // });

    const labelData = {
        "labelRootError": error,
        "labelRootSuccess": success && !error
    }
    const labelKeys = getKeyArray(labelData);


    const underlineData = {
        "underlineError": error,
        "underlineSuccess": success && !error,
        "underline": true
    };
    const underlineKeys = getKeyArray(underlineData);


    const items = options ? options : [];

    return (
        <FormControl
            {...formControlProps}
            sx={getBaseSxStyle(styles, ['formControl'])}
        >
            {
                labelText !== undefined
                    ? (<InputLabel
                        {...labelProps}
                        shrink={true}
                        sx={getBaseSxStyle(styles, ['labelRoot', ...labelKeys])}
                        htmlFor={id}
                    >
                        {labelText}
                    </InputLabel>)
                    : null
            }
            <Select
                sx={getBaseSxStyle(styles, ['root', 'disabled'])}
                id={id}
                input={
                    <Input
                        {...inputProps}
                        sx={getBaseSxStyle(styles, [...underlineKeys])}
                    />
                }
            >
                {items.map((x, index) => (
                    <MenuItem key={x.value + index + id ?? ""} value={x.value}>
                        {x.label}
                    </MenuItem>
                ))}
            </Select>
            {
                error
                    ? (<Clear sx={getBaseSxStyle(styles, ['feedback', 'labelRootError'])} />)
                    : success
                        ? (<Check sx={getBaseSxStyle(styles, ['feedback', 'labelRootSuccess'])} />)
                        : null
            }
        </FormControl>
    );
}

CustomSelect.propTypes = {
    labelText: PropTypes.node,
    labelProps: PropTypes.object,
    id: PropTypes.string,
    inputProps: PropTypes.object,
    formControlProps: PropTypes.object,
    options: PropTypes.array,
    error: PropTypes.bool,
    success: PropTypes.bool,
};
